export default __webpack_public_path__ + "static/media/No.7-1.2861f94f.jpg";